const o = (t = 16) => parseInt(
  Math.ceil(Math.random() * Date.now()).toPrecision(t).toString().replace(".", "")
);
export {
  o
};
//# sourceMappingURL=UniqIdUtils-2f7d9836.mjs.map
